<template>
    <div>
        <router-view />
        <v-snackbar
            :value="isShowSnackBarModal"
            absolute
            top
            :color="statusSnackBarModal"
            :timeout="timeoutSnackBarModal"
        >
            <span>{{ messageSnackBarModal }}</span>
            <v-icon dark>mdi-checkbox-marked-circle</v-icon>
        </v-snackbar>
    </div>
</template> 

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'App',
        computed: {
            ...mapGetters('snackBarModules', ['isShowSnackBarModal', 'statusSnackBarModal', 'timeoutSnackBarModal', 'messageSnackBarModal']),
        },
    }
</script>

<style lang="scss">
    .v-snack > .success {
        background-color: rgb(76, 175, 80);
        border-color: rgb(76, 175, 80);
    }
    .v-snack > .error {
        background-color: #ff5252;
        border-color: #ff5252;
    }

    .v-snack--top {
        top: calc(100vh - 55%) !important;
    }

    .v-snack__content {
        min-height: 60px !important;
        font-family: "Roboto", sans-serif;
    }

    .v-dialog label.v-label {
        color: #888888 !important;
    }
</style>
